import axios from 'axios';

// Чтобы понимать, что запросы от axios - это ajax-запросы
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';